import { OnboardingV2Step } from '../../redux/onboardingTypes';
import { ContinueRef } from '../../onboarding/types';
import SignUpForm from '../forms/SignUpForm';
import SecondForm from '../forms/SecondForm';
import CountryForm from '../forms/CountryForm';
import SelectCountryForm from '../forms/SelectCountryForm';
import GenderForm from '../forms/GenderForm';
import AddressV2 from '../forms/AddressvV2';
import StripeForm from '../forms/StripeForm';
import SummaryV2Form from '../forms/SummaryV2Form';

interface FormContentProps {
  step: OnboardingV2Step;
  formRef: React.RefObject<ContinueRef>;
}

export default function FormContent({ step, formRef }: FormContentProps) {
  switch (step) {
    case OnboardingV2Step.SECOND_FORM:
      return <SecondForm ref={formRef} />;
    case OnboardingV2Step.COUNTRY:
      return <CountryForm ref={formRef} />;
    case OnboardingV2Step.COUNTRY_SELECT:
      return <SelectCountryForm />;
    case OnboardingV2Step.GENDER:
      return <GenderForm ref={formRef} />;
    case OnboardingV2Step.BILLING_ADDRESS:
      return <AddressV2 ref={formRef} type="billing" />;
    case OnboardingV2Step.DELIVERY_ADDRESS:
      return <AddressV2 ref={formRef} type="delivery" />;
    case OnboardingV2Step.PAYMENT_INFO:
      return <StripeForm ref={formRef} />;
    case OnboardingV2Step.SUMMARY:
      return <SummaryV2Form ref={formRef} />;
    case OnboardingV2Step.SIGN_UP:
    default:
      return <SignUpForm ref={formRef} />;
  }
}
